<template>
  <cst-page-template :hide-menu="true" class="purchase-order-overview-page">
    <header-menu />
    <pcqm-dashboard-warning-container />
    <div class="o-row-full dashboard-header">
      <div class="container">
        <new-configuration :is-purchase-order="true" />
      </div>
    </div>

    <div class="container">
      <purchase-order-overview />
    </div>
  </cst-page-template>
</template>

<script>
import CstPageTemplate from '@/templates/CstPageTemplate.vue'
import PurchaseOrderOverview from '@/components/generic/presentational/organisms/purchaseOrderOverview/PurchaseOrderOverview.vue'
import NewConfiguration from '@/components/generic/presentational/molecules/newConfiguration/NewConfiguration.vue'
import PcqmDashboardWarningContainer from '@/components/generic/presentational/molecules/pcqmDashboardWarningContainer/PcqmDashboardWarningContainer.vue'
import HeaderMenu from '@/components/generic/presentational/molecules/headerMenu/HeaderMenu.vue'

export default {
  components: {
    CstPageTemplate,
    NewConfiguration,
    PurchaseOrderOverview,
    PcqmDashboardWarningContainer,
    HeaderMenu,
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  padding: 0 1.5rem;
  display: grid;
  row-gap: 20px;
}

.dashboard-header {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  background: $gray-lightest;
}
</style>
